import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=b4bd235e&scoped=true"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=b4bd235e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bd235e",
  null
  
)

export default component.exports